import React from 'react'
import { useIntl } from 'react-intl'
import { useRecoilValue } from 'recoil'
import { modalCheckup } from 'Pages/OverviewMessage/recoil/state/modal'
import CheckItem from 'Components/CheckItem/CheckItem'
import { EmailMessageCheckUpIssueType } from 'Constants/'

const ImprovementsCheck = () => {
  const intl = useIntl()

  const {
    checkPreheader,
    checkWebAnalytics,
    silencedAlertsArray,
    checkCustomDomainCustomizable
  } = useRecoilValue(modalCheckup)

  const props = () => ({
    icon: 'info',
    badge: intl.formatMessage({
      id: 'Load.EmailCheckUp.InfoLabel'
    })
  })

  return (
    <div className='c-improvements-issue'>
      {!checkPreheader &&
        !silencedAlertsArray.find(
          e => e.issueType === EmailMessageCheckUpIssueType.PreheaderInfo
        ).silenced && (
          <CheckItem
            {...props()}
            title={intl.formatMessage({
              id: 'Load.EmailCheckUp.PreheaderInfo'
            })}
          />
        )}

      {!checkWebAnalytics &&
        !silencedAlertsArray.find(
          e =>
            e.issueType ===
            EmailMessageCheckUpIssueType.WebAnalyticsTrackingInfo
        ).silenced && (
          <CheckItem
            {...props()}
            title={intl.formatMessage({
              id: 'Load.EmailCheckUp.WebAnalyticsTrackingInfo'
            })}
          />
        )}

      {checkCustomDomainCustomizable &&
        !silencedAlertsArray.find(
          e => e.issueType === EmailMessageCheckUpIssueType.DomainCustomizable
        ).silenced && (
          <CheckItem
            {...props()}
            title={intl.formatMessage({
              id: 'Load.EmailCheckUp.CustomTrackingDomainKo'
            })}
          />
        )}
    </div>
  )
}

export default ImprovementsCheck
